module.exports = __webpack_public_path__ + "img/growth-p-1080.d484c193.png";